import { useTranslation } from 'react-i18next';
import {
  BlockedWrapper,
  BlockedCard,
  BlockedHeading,
  BlockedBody,
  BlockedCta,
} from './AccessBlocked.styled';

export default function AccessBlocked() {
  const { t } = useTranslation();

  return (
    <BlockedWrapper>
      <BlockedCard role="alert">
        <BlockedHeading>{t('billing.access.blockedHeading')}</BlockedHeading>
        <BlockedBody>{t('billing.access.blockedBody')}</BlockedBody>
        <BlockedCta to="/settings">{t('billing.access.blockedCta')}</BlockedCta>
      </BlockedCard>
    </BlockedWrapper>
  );
}
